import { withNavigationWatcher } from "./contexts/navigation";
import CarDetailPage from "./pages/car-detail";
import FilterPage from "./pages/filterpage";
import GaragePage from "./pages/garage";
import HomePage from "./pages/homepage";
import OfferGaragePage from "./pages/offer-garage";

const routes = [
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/cars",
    component: FilterPage,
  },
  {
    path: "/car-details/:id",
    component: CarDetailPage,
  },
  {
    path: "/garage",
    component: GaragePage,
  },
  {
    path: "/garage/:Id",
    component: OfferGaragePage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
